import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQueryWithoutAuth } from "./base-query";
import { IUserRole } from "@/types/family-user-role/family-user-role";

export const userRolesApi = createApi({
  reducerPath: "userRoleApi",
  baseQuery: baseQueryWithoutAuth,
  tagTypes: ['UserRole'],
  endpoints: (builder) => ({
    getUserRoles: builder.query<Array<IUserRole>, void>({
      query: () => {
        return {
          // Public list of user types selectable at registration
          url: '/user-types',
        }
      },
      providesTags: (result) => ['UserRole'],
    }),
  })
});

export const { useGetUserRolesQuery } = userRolesApi;